import { Box, Button, Flex, Heading, Text, VStack } from '@chakra-ui/core';
import { ChevronRightIcon } from '@chakra-ui/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import RevealSeed from '../../components/RevealSeed';
import { RootState } from '../../store/reducers';

const WalletPassphrase = ({ onBack, onNext }) => {
  const mnemonic = useSelector((state: RootState) => state.wallet.mnemonic);

  return (
    <>
      <Box width="30em">
        <VStack spacing={4} alignItems="normal">
          <Heading as="h5" size="sm">
            Secret Backup Phrase
          </Heading>
          <Text fontSize="sm">
            Your secret backup phrase makes it easy to back up and restore your
            account. Please store it somewhere safe.
          </Text>
          <Text fontSize="xs">
            WARNING: Never disclose your backup phrase. Anyone with this phrase
            can steal the funds you've deposited.
          </Text>
          <RevealSeed mnemonic={mnemonic} />
        </VStack>
      </Box>
      <Flex flexDir="row" mt={4}>
        <Button onClick={onBack}>Go Back</Button>
        <Button
          ml="auto"
          colorScheme="blue"
          rightIcon={<ChevronRightIcon />}
          onClick={onNext}
        >
          Setup Wallet
        </Button>
      </Flex>
    </>
  );
};

export default WalletPassphrase;
